import {ApplicationState, rootReducer} from "./reducers";
import {applyMiddleware, compose, createStore, Store} from "redux";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import thunk from "redux-thunk"

export default function configureStore(initialState: ApplicationState): Store<ApplicationState>{
    const composeEnhancers = window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] as typeof compose || compose; // add support for Redux dev tools

    return createStore(
        rootReducer,
        initialState,
        composeEnhancers(applyMiddleware(thunk, reduxImmutableStateInvariant({
            ignore: [
                "recoleccionDestino", 
                "mercancias.0.etiquetaEmbalaje",
                "recoleccionOrigen"
            ]
        })))
    );
}
